import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Accent, SectionHeading } from './SectionHeading';
import { TeachingFlow } from './TeachingFlow';
import { newWorkflow, oldWorkflow } from '../../data/content';

/** Section 9 — the hidden hours behind one class, crossed out. */
export function TimeSavingSection() {
  const reduceMotion = useReducedMotion();
  return <section aria-labelledby="time-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-215" data-mp="zboxpkkogsx4">
      <div className="mx-auto max-w-5xl" data-id="element-216" data-mp="14a8l7pex6crl">
        <SectionHeading id="time-heading" title={<>
              Think About the Hours Hidden Behind <Accent data-id="element-218" data-mp="197i8ozir0ecs">ONE Class.</Accent>
            </>} data-id="element-217" data-mp="14b9vhro42v89" />

        <div className="mt-14 grid items-center gap-8 md:grid-cols-[0.9fr_1.1fr] md:gap-12" data-id="element-219" data-mp="1e1w8de4g17n9">
          <div className="rounded-[20px] border border-brand-charcoal/12 bg-white/60 px-6 py-8 sm:px-8" data-id="element-220" data-mp="gk4jjnlakn38">
            <p className="font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-charcoal/50" data-id="element-221" data-mp="lifuk1nbp3n1">
              The usual way
            </p>
            <ol className="mt-5" data-id="element-222" data-mp="6ku6k2hb1pwc">
              {oldWorkflow.map((step, index) => <li key={step} className="flex flex-col items-start" data-id="element-223" data-mp="1udr6ctxbu7c" data-mpi={index}>
                  <span className="relative inline-block py-1 text-[16px] text-brand-charcoal/55" data-id="element-224" data-mp="1sj3wrv6jq03">
                    {step}
                    <motion.span aria-hidden="true" className="absolute left-[-4px] right-[-4px] top-1/2 h-[2px] origin-left bg-brand-plum/70" initial={{
                  scaleX: reduceMotion ? 1 : 0
                }} whileInView={{
                  scaleX: 1
                }} viewport={{
                  once: true,
                  amount: 0.8
                }} transition={{
                  duration: 0.25,
                  delay: reduceMotion ? 0 : index * 0.05,
                  ease: [0.23, 1, 0.32, 1]
                }} data-id="element-225" data-mp="3oz212olqr8se" />
                  </span>
                  {index < oldWorkflow.length - 1 && <span aria-hidden="true" className="pl-3 text-[12px] leading-none text-brand-charcoal/30" data-id="element-226" data-mp="196cpkeqi6bn4">
                      ↓
                    </span>}
                </li>)}
            </ol>
          </div>

          <div className="rounded-[24px] bg-brand-plum-dark px-6 py-10 text-center text-white shadow-[0_30px_60px_-30px_rgba(59,27,87,0.7)] sm:px-10" data-id="element-227" data-mp="2tr9lqmhnr9ef">
            <p className="font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-lilac" data-id="element-228" data-mp="3lheaexcgailg">
              With Makeup Instructor Ready
            </p>
            <TeachingFlow steps={newWorkflow} size="lg" tone="light" className="mt-6" data-id="element-229" data-mp="3qfplfbehez59" />
            <div className="mx-auto mt-8 max-w-md space-y-2 text-[15px] leading-relaxed text-white/80" data-id="element-230" data-mp="3cg7r6gif2toi">
              <p className="font-semibold text-white" data-id="element-231" data-mp="3he9a91fueszz">
                Makeup Instructor Ready doesn't replace your expertise. It gives your expertise a ready-to-use
                structure.
              </p>
              <p data-id="element-232" data-mp="261ymj9fyhn2e">Your knowledge remains yours. Your teaching style remains yours.</p>
              <p data-id="element-233" data-mp="1xi25mtl6g8x1">You simply stop beginning every class with an empty page.</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}